import React, { useEffect, useState, useContext } from 'react'
import { useFormContext } from "react-hook-form";
import { Card, CardContent, Grid } from '@material-ui/core'
import { components, DataFlattener, useTranslation, useServices } from 'cng-web-lib'
import makeValidationSchema from './ValidationSchema'
import Namespace from 'src/constants/locale/Namespace'
import CommunicationUtilKeys from 'src/constants/locale/key/CommunicationUtil'
import RegularButton from 'src/components/CustomButton';
import CciHsCodeClassificationApiUrls from 'src/apiUrls/CciHsCodeClassificationApiUrls.js'
import CngBackdrop from 'src/components/cngcomponents/CngBackDrop';


const {
  card: { },
  form: {
    field: { CngTextField, CngSelectField, CngCodeMasterAutocompleteField }
  },
  CngGridItem,
  button: { CngButton }
} = components

const customStyles = `

.muted {
  color: #6b7280;
  font-size: 14px;
}

.hs-result {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 0;
  border-bottom: 1px solid #e5e7eb;
}

.hs-code {
  font-weight: 600;
  color: #2563eb;
}

.hs-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
}

.copy-icon {
  cursor: pointer;
  font-size: 16px;
}

.copy-icon:hover {
  opacity: 0.7;
}

.info-wrapper {
  position: relative;
  font-size: 14px;
  color: #6b7280;
  cursor: pointer;
}

.tooltip {
  position: absolute;
  top: -8px;
  left: 18px;
  width: 260px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 10px;
  font-size: 12px;
  color: #374151;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease;
  z-index: 10;
}

.info-wrapper:hover .tooltip {
  opacity: 1;
}

.empty-state {
  height: 100%;
  min-height: 391px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #9ca3af;
  font-size: 14px;
  gap: 12px;
}

.empty-icon {
  font-size: 28px;
  color: #9ca3af;
}

.copy-icon {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #888;
  cursor: pointer;
  transition: color 0.15s;
}
.copy-icon:hover {
  color: #333;
}
.copied-label {
  font-size: 12px;
  font-weight: 500;
  color: #1a9e75;  /* green to signal success */
}
.copy-icon svg {
  flex-shrink: 0;
}
`;

const DEFAULT_INITIAL_VALUES = Object.freeze({
  countryCode: "",
  description: "",
})

const FORMIK_PROPS = {
  initialValues: { ...DEFAULT_INITIAL_VALUES },
  makeValidationSchema: makeValidationSchema
}

function Fields({ disabled, showNotification, shouldHideMap }) {
  const { setValue, getValues, reset, watch, trigger } = useFormContext();
  const { securedSendRequest } = useServices();
  const [loading, setLoading] = useState(false);
  const [copied, setCopied] = useState(null);

  const status = watch('status')
  const description = watch('description')
  const [results, setResults] = useState([]);
  const [country, setCountry] = useState("CAN");
  const { translate } = useTranslation(Namespace.COMMUNICATION_UTIL)
  const countryCode = watch('countryCode')

  const classifyNow = () => {

    const errors = [];

    if (!getValues("countryCode")) {
      errors.push("Please choose the country");
    }
    if (!getValues("description")) {
      errors.push("Description cannot be empty");
    }

    if (errors.length > 0) {
      errors.forEach(msg => showNotification("error", msg));
      return;
    }
    setLoading(true);
    securedSendRequest.execute('POST', CciHsCodeClassificationApiUrls.SEARCH, getValues(),
      (response) => {
        if (response.status === 200) {
          if (response.data) {
            console.log(response)
            var errorFlag = false
            var obj = response.data;
            console.log(obj)
            if (obj.errorMessage != null && obj.errorMessage.length > 0) {
              for (let error of obj.errorMessage) {
                showNotification('error', error);
              }
              errorFlag = true
            }
            if (!errorFlag) {
              setResults(response.data.results);
            }
          }
        }
      },
      (error) => {
        console.error(error)
        setResults([])
        showNotification('error', "We've encountered some issue. Please try again later.");
      },
      () => setLoading(false)
    );
  };

  const copyToClipboard = (code) => {
    navigator.clipboard.writeText(code);
  };

  const handleCopy = (code) => {
    copyToClipboard(code);
    showNotification("success", "Copied to clipboard - " + code)
    setCopied(code);
    setTimeout(() => setCopied(null), 1500);
  };

  const CopyIcon = () => (
    <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
      <rect x="7" y="5" width="10" height="12" rx="1.5" stroke="currentColor" strokeWidth="1.25" />
      <path
        d="M5 14H4a1 1 0 01-1-1V4a1 1 0 011-1h8a1 1 0 011 1v1"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
    </svg>
  );

  const CheckIcon = () => (
    <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
      <polyline
        points="4,10 8,14 16,6"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  return (<>

    {/* <Card>
      <CardContent>
        <Grid container spacing={1}>
          <CngGridItem xs={12} sm={12} style={{ paddingBottom: 5 }}><h1>HS Classification</h1></CngGridItem>
          <CngGridItem xs={12} sm={12} style={{ color: "grey", paddingTop: 0 }}><p>Enter product description to generate HS code suggestions</p></CngGridItem>
        </Grid>
      </CardContent>
    </Card>  */}

    <Grid container spacing={2}>
      <CngGridItem xs={12} sm={9}>
        <CngBackdrop loading={loading} />
      </CngGridItem>
      <Grid item xs={12} md={6}>
        <Card className="rounded-2xl">
          <CardContent className="p-6 space-y-4">
            <CngGridItem xs={12} sm={12}><p>Product Description</p></CngGridItem><br />
            <CngGridItem xs={12} sm={12} shouldHide={shouldHideMap.gender}>
              <CngCodeMasterAutocompleteField
                name='countryCode'
                key={countryCode}
                label='Country'
                disabled={disabled}
                size='small'
                codeType='CCI_COUNTRY'
              />
            </CngGridItem><br />
            <CngGridItem xs={12} sm={12}>
              <CngTextField name="description" multiline rows={12} placeholder={
                "Describe your product in detail. Include information such as:\n\n" +
                "• Product name and type\n" +
                "• Material composition\n" +
                "• Intended use\n" +
                "• Key features\n" +
                "• Technical specifications"
              }
              inputProps={{ maxLength: 512 }}/>
            </CngGridItem><br />
            <CngGridItem xs={12} sm={12}>

              <RegularButton variant="outlined" onClick={classifyNow} style={{
                width: "100%"
              }}>
                ✨ Classify Now
              </RegularButton>
            </CngGridItem>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} md={6}>
        <Card className="rounded-2xl">
          <CardContent className="p-6 space-y-4">
            <CngGridItem xs={12} sm={12} style={{ display: "flex", gap: "6px" }}><p>HS Code Suggestions</p> <div className="info-wrapper">ⓘ
              <div className="tooltip">
                Confidence score is AI-generated. HS codes are for reference only and
                must be validated before use.
              </div>
            </div></CngGridItem><br />
            <CngGridItem xs={12} sm={12}>
              {results.length === 0 ? (
                <div className="empty-state">
                  <div className="empty-icon">✨</div>
                  <p>
                    Enter a product description and click{" "}
                    <strong>“Classify Now”</strong> to see HS code suggestions
                  </p>
                </div>
              ) : (
                results.map((item) => (
                  <div key={item.hs_code} className="hs-result">
                    <div style={{ flex: 1 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <div className="hs-code">{item.hs_code}</div>
                        <span
                          className="copy-icon"
                          title={copied === item.hs_code ? "Copied!" : "Copy HS Code"}
                          onClick={() => handleCopy(item.hs_code)}
                        >
                          {copied === item.hs_code ? (
                            <>
                              <CheckIcon />
                              <span className="copied-label">Copied!</span>
                            </>
                          ) : (
                            <CopyIcon />
                          )}
                        </span>
                      </div>
                      <div className="muted">{item.hs_code_description}</div>
                    </div>

                    <div className="hs-right">
                      <span>{Math.round(item.confidence_score * 100)}%</span>
                    </div>
                  </div>
                )))}
            </CngGridItem>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
    <style>{customStyles}</style>
  </>
  )
}

function toClientDataFormat(serverData) {
  let localData = DataFlattener.parse(serverData);
  return localData;
}

function toServerDataFormat(localData) {
  return DataFlattener.unflatten(localData);
}

const FormProperties = Object.freeze({
  formikProps: FORMIK_PROPS,
  Fields: Fields,
  toClientDataFormat: toClientDataFormat,
  toServerDataFormat: toServerDataFormat
})

export default FormProperties
